import React from "react";
import Skeleton from "./Skeleton";
import PropTypes from "prop-types";

export const RectSkeleton = ({ height = "100%", width = "100%" }) => {
  return <Skeleton variant="rectangular" width={width} height={height} />;
};

RectSkeleton.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};
